import React from 'react'
import styled from 'styled-components'

const SwapInputPanel = styled.div<{ short?: boolean }>`
  color: ${({ theme }) => theme.tradeInputPanelTextColor};
  background-color: ${({ theme }) => theme.tradeInputPanelBackgroundColor};
  border: 1px solid ${({ theme }) => theme.tradeInputPanelBorderColor};

  border-radius: 3rem;
  font-size: 1em;
  justify-content: space-between;
  margin: 1px;
  overflow: hidden;
  padding: 1rem 1.5rem 1rem 1rem;
  outline: none;
  text-decoration: none;
  text-align: left;

  display: flex;
  flex-direction: column;

  :hover {
    border: 1px solid ${({ theme }) => theme.tradeInputPanelBorderColorHover};
  }

  /* Tablets */
  @media (max-width: 1400px) {
    border-radius: 2.5rem;
    font-size: 1em;
  }

  /* Mobiles */
  @media (max-width: 640px) {
    border-radius: 2.25rem;
    font-size: 1em;
    width: ${({ short }) => (short ? '300px' : '350px')};
  }
`

export default SwapInputPanel
